import { render, staticRenderFns } from "./WordToggle.vue?vue&type=template&id=6307eed8&"
import script from "./WordToggle.vue?vue&type=script&lang=ts&"
export * from "./WordToggle.vue?vue&type=script&lang=ts&"
import style0 from "./WordToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports